import React, { useEffect, useContext, useState } from "react";
import Box from "@mui/material/Box";
import "react-toastify/dist/ReactToastify.css";

export default function Terms() {

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: '#9AD17A',
        flexGrow: 1,
        height: "100vh",
        overflow: "auto",
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
       

      </div>
    </Box>
  );
}